const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

export const getAssetViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Info'),
      fields: [{ text: t('Nome'), value: display(item.title) }],
    },
  ];
};
